import {ChangeDetectorRef, Component, Inject, NgZone, OnInit, QueryList, ViewChildren,} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MapInfoWindow, MapMarker} from '@angular/google-maps';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-google-maps-modal',
    templateUrl: './google-maps-modal.component.html',
    styleUrls: ['./google-maps-modal.component.scss'],
    standalone: false
})
export class GoogleMapsModalComponent implements OnInit {
  @ViewChildren(MapInfoWindow) infoWindows: QueryList<MapInfoWindow>;
  @ViewChildren(MapMarker) mapMarkers: QueryList<MapMarker>;

  mapLoaded = false;
  center: google.maps.LatLngLiteral = { lat: 40.73061, lng: -73.935242 };
  zoom = 10;
  markers: IMarker[] = [];

  constructor(
    public cd: ChangeDetectorRef,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: { id: number; latitude: number; longitude: number; storeName: string }[],
  ) {}

  ngOnInit(): void {
    this.data.forEach((item) => {
      this.markers.push({
        id: item.id,
        lat: item.latitude,
        lng: item.longitude,
        title: item.storeName,
        draggable: false,
      });
    });
    if (this.data.length === 1) {
      this.center = { lat: this.markers[0].lat, lng: this.markers[0].lng };
      this.zoom = 14;
    }
    this.loadMapScript();
  }

  private loadMapScript(): void {
    if (typeof google !== 'undefined' && google.maps) {
      this.mapLoaded = true;
      this.cd.detectChanges();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.ngZone.run(() => {
        this.mapLoaded = true;
        this.cd.detectChanges();
      });
    };
    document.head.appendChild(script);
  }

  openInfoWindow(index: number): void {
    const marker = this.mapMarkers?.get(index);
    const infoWindow = this.infoWindows?.get(index);
    if (marker && infoWindow) {
      infoWindow.open(marker);
    }
  }
}

interface IMarker {
  id: number;
  lat: number;
  lng: number;
  title?: string;
  draggable: boolean;
}
